import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { strict } from 'assert';
import * as ngswal from "sweetalert";
import { ApiMethod } from '../apimethods/api-method';
import { GlobalConstants } from '../common/global-constants';
import { AuthorEPTInstructionModel } from './authorept-instruction-model';
declare var $;

@Component({
  selector: 'app-authorept-instruction',
  templateUrl: './authorept-instruction.component.html',
  styleUrls: ['./authorept-instruction.component.css']
})
/** authorept-instructioncomponent*/
export class authoreptinstructionComponent implements OnInit {
  modelItem = new AuthorEPTInstructionModel();
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
  dataSet: string;
  title: string;
  dataTable: any;
  showModal: boolean;
  popUpButtonText: string;
  publisher: any;
  InstructionList: String;
  ModalButton: any;
  showInstructionsModal: boolean;
  InstructionTitle: any;
  InstructionItem: any;
  PublisherId: any;
  count: string;

  /** authorept-instruction ctor */
  ngOnInit(): void {
    ApiMethod.getBaseUrl();
    $('#Txt_InstructionItem').jqte();
  }

  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <AuthorEPTInstructionModel>data["AuthorEptInstructionPage"];
        //this.GetPublisher();
        //this.GetDataProofingEPTById();
        this.GetDataProofingEPT();


        //publisher list
        $("#ddlPublisher").select2({
          placeholder: "Select Publisher", dropdownParent: "#divMainFilter"
        });
        $('#ddlPublisher').val('All').trigger('change');

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  //GetPublisher(): void {
  //  ApiMethod.getMethod(this.modelItem.GetPublisher).subscribe(
  //    result => {
  //      this.publisher = result.aPublisher;

  //    }, error => {


  //      ngswal("Warning !", error, "warning");

  //    });
  //}

  //resetFilter() {
  //  $('#ddlPublisher').val(0).change();
  //  this.GetDataProofingEPT();
  //}

  // ExtractLiTexts
  extractLiTexts(apiString: string): string[] {
    // console.log(apiString);
    const ulStartIndex = apiString.indexOf('<ul>');
    const ulEndIndex = apiString.indexOf('</ul>');
    if (ulStartIndex !== -1 && ulEndIndex !== -1) {
      const ulContent = apiString.slice(ulStartIndex + 4, ulEndIndex);
      const liTexts = ulContent.split('<li>').slice(1).map(item => item.split('</li>')[0].trim());
      return liTexts;
    } else {
      return [];
    }
  }

  //String merge
  createHtmlFromList(items: string[]): string {
    let htmlString: string = '<ul>';
    items.forEach(html => {
      htmlString += `<li>${html}</li>`;
    });
    htmlString += '</ul>';
    return htmlString;

  }

  // h4 tag merge
  createHtmlh4(items: string[]): string {
    let htmlString: string = '';
    items.forEach(html => {
      htmlString += `<h4>${html}</h4>`;
    });
    return htmlString;
  }

  // show the table content
  GetDataProofingEPT(): void {

    ApiMethod.getMethod(this.modelItem.GetDataProofingEPT + "/" + localStorage.aPubID).subscribe(
      Response => {
        let item = Response.aResult;
        let InstructionItem: string[] = this.extractLiTexts(item[0].InstructionItem);
        let InstructionTitle: string = this.removeTags(item[0].InstructionTitle);
        $("#Txt_InstructionTitle").val(InstructionTitle);
        $("#tblAddList tbody").html("");
        let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
        let Delete = "style='color: #f46a6a; font-size: 20px;cursor:Pointer;'";
        if (InstructionItem.length != 0) {
          var nRowL = "";
          for (var i = 0; i < InstructionItem.length; i++) {
            nRowL += "<tr id='trsc_" + (i + 1).toString() + "'>";
            nRowL += "<td>" + (i + 1).toString() + "</td>";
            nRowL += "<td>" + GlobalConstants.isNullCheck(InstructionItem[i]) + "</td>";
            nRowL += "<td style='text-align: center'>"
              + "<i class='bx bxs-edit-alt' title='Edit' " + styleEdit + " onclick=localStorage.aEID='" + (i + 1).toString() + "';$('#spUpdateitem').trigger('click');></i>&nbsp;"
              + "<i class='bx bxs-trash DeleteRow' " + Delete + " onclick=localStorage.aEID='" + (i + 1).toString() + "';$('#btnDeleteConfirm').trigger('click');></i>"
              + "</td>";
            nRowL += "</tr>";
          }
          $("#tblAddList tbody").append(nRowL);
        }
      }, error => {
        ngswal("Failed !", error.message, "error");
      });
  }
  removeTags(str: string): string {
    return str.replace(/(<([^>]+)>)/ig, '');
  }
  //show the Instruction Details
  GetDataProofingEPTById() {
    $('#Divmail .jqte_editor').css({ 'height': (GlobalConstants.size.height - 800), 'resize': 'none' });  //jqte
    this.showInstructionsModal = true;
    this.clear();
    if (localStorage.aEID != 0) {
      let trId = "#trsc_" + localStorage.aEID;
      $('#Divmail .jqte_editor').html($(trId).find('td')[1].innerHTML);
      this.title = "Update EPT-Instruction";
      this.ModalButton = "Update";

    }
    else {
      this.title = " Add EPT-Instruction ";
      this.ModalButton = "Save";
    }
    error => {
      ngswal("Failed !", error.error.Message, "warning");
    }
  }
  addTableProofingEPT() {
    if (localStorage.aEID != 0) {
      let trId = "#trsc_" + localStorage.aEID;
      $(trId).find("td")[1].outerHTML = "<td>" + $("#Txt_InstructionItem").val() + "</td>";
      this.hide();
    } else {
      var nRowL = "";
      let styleEdit = "style='color: #34c38f; font-size: 20px;cursor:Pointer;'";
      let Delete = "style='color: #f46a6a; font-size: 20px;cursor:Pointer;'";
      var zRowLength = $("#tblAddList").find("tr").length;
      nRowL += "<tr id='trsc_" + zRowLength.toString() + "'>";
      nRowL += "<td>" + zRowLength.toString() + "</td>";
      nRowL += "<td>" + $("#Txt_InstructionItem").val() + "</td>";
      nRowL += "<td style='text-align: center'>"
        + "<i class='bx bxs-edit-alt' title='Edit' " + styleEdit + " onclick=localStorage.aEID='" + zRowLength.toString() + "';$('#spUpdateitem').trigger('click');></i>&nbsp;"
        + "<i class='bx bxs-trash DeleteRow' " + Delete + " onclick=localStorage.aEID='" + zRowLength.toString() + "';$('#btnDeleteConfirm').trigger('click');></i>"
        + "</td>";
      nRowL += "</tr>";
      $("#tblAddList tbody").append(nRowL);
      this.hide();

    }
  }
  //Hide Function
  hide() {
    this.showInstructionsModal = false;
    localStorage.aEID = 0;
  }
  //Clear Function
  clear() {
    $('#Divmail .jqte_editor').html('');
  }


  //Update
  AddUpdateProofingInstruction() {
    var getCorrectionItem = GlobalConstants.GetTableRowToList("tblAddList", null, true);
    this.GetTableRowToList("tblAddList");
    let InstructionItem: string[] = [];
    //alert(getCorrectionItem);
    getCorrectionItem.forEach(item => {
      InstructionItem.push(item[1]);
    });
    //add tags in array content
    var Instruction = this.createHtmlFromList(InstructionItem);
    var createheading = "<h4>" + $('#Txt_InstructionTitle').val() + "</h4>";
    var updatedData = {
      PublisherId: localStorage.aPubID,
      InstructionItem: Instruction,
      InstructionTitle: createheading,
    }

    ApiMethod.postMethod(this.modelItem.AddUpdateProofingInstruction, updatedData).subscribe(
      response => {
        if (InstructionItem.length === 0) {
          ngswal({
            position: 'top-end',
            type: "warning",
            title: "Warning!",
            text: "Maintain Atleast one instruction record !",
            showConfirmButton: true
          });
          return; // Stop the function execution
        }
        else {
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.aItem,
            showConfirmButton: true,
          });
        }
      },
      error => {
        ngswal("Failed !", error.Message, "warning");
      }
    );
  }
  // Delete Confirmation Pop-Up
  DeleteConfirm() {
    //var rowCount = $('#tblAddList tbody tr').length;
    //if (rowCount <= 1) {
    //  ngswal("Warning !", "Maintain Atleast one instruction record !", "warning");
    //  $('.DeleteRow').off('click');
    //  return false;
    //} 
    ngswal({
      title: "Are you confirm to delete EPT Instrucions?",
      text: "You will not be able to recover this data!",
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $("#trsc_" + localStorage.aEID).closest("tr").remove();

          $("table#tblAddList tbody").each(function () {
            $(this).children().each(function (index) {
              $(this).find("td").first().html((index + 1).toString());
            });
          });
          ngswal("Deleted!", "Your data has been deleted.", "success");
        } else {
          ngswal("Cancelled", "Your data is safe :)", "warning");
          return false;
        }
      });

  }


  GetTableRowToList(zTableID: string) {
    const getResultList: string[] = [];
    const table = document.getElementById(zTableID) as HTMLTableElement;
    const rows = table.getElementsByTagName('tr');
    for (let i = 0; i < rows.length; i++) {
      const cells = rows[i].getElementsByTagName('td');
      for (let j = 0; j < cells.length; j++) {
        getResultList.push(cells[j].innerHTML);
      }
    }
    return getResultList;
  }


}
